module.exports = __webpack_public_path__ + "static/img/12_pro.3b56b86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/12_pro.jpg
// module id = Pl62
// module chunks = 0